/**
 * @generated SignedSource<<3510aed72f4910b0d9e1487dcdf1aca4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paywallsGetArticlePaywallTagArticle$data = {
  readonly flag: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle" | "helpersGetArticleTypeArticle" | "helpersIsArchiveWallArticle" | "helpersIsLiteWallArticle" | "helpersIsPlusInlinePaywall" | "helpersIsSignInWallArticle" | "helpersIsVelocityWallArticle">;
  readonly " $fragmentType": "paywallsGetArticlePaywallTagArticle";
};
export type paywallsGetArticlePaywallTagArticle$key = {
  readonly " $data"?: paywallsGetArticlePaywallTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"paywallsGetArticlePaywallTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paywallsGetArticlePaywallTagArticle"
};

(node as any).hash = "ac6e3ba7a4e9281836d00ee734530e24";

export default node;
